import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AutoComplete from "../AutoComplete";
import { useDispatch, useSelector } from "react-redux";
import { setIsUpdatedStaff, setStaffDetails } from "../../redux/reducers/dataCaptures";
import { isEmpty } from "../../common/StaticExports";

const StaffMemberRolesAutocomplete = (props:any) => {
    const { role, isReadOnly } = props;
    const [t] = useTranslation();
    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState([]);
    const staffList = useSelector((state:any) => state.dataCaptures.staffDetails);
    const dispatch = useDispatch();
    
    useEffect(() => {
      const opts = staffList ? staffList
        ?.filter((el: any) => el.id !== null)
        ?.map((el: any) => {
          return { id: el.id, name: el.kanjiName, leadershipRole: el.leadershipRole };
        }) : [];
      // @ts-ignore
      setOptions(opts);
    }, [staffList]);

    useEffect(() => {
      const selected = options.filter((el:any) => el.leadershipRole.some((el:any) => el === role));
      const selectedIds:any = selected.map((el:any) => el.id);
      setSelectedOption(selectedIds);
    }, [role, options]);

    const handleChange = (selected: any) => {
      let opts = [...selectedOption, selected];
      opts?.forEach((el:any) => {
        const user = staffList?.find((user:any) => user.id == el.id);
        if (user) {
          if (!user.leadershipRole?.includes(role)) {
            const updatedStaff = {...user, leadershipRole: [...user.leadershipRole, role]};
            const updatedList = staffList?.map((item:any) => item?.id == updatedStaff?.id ? updatedStaff : item);
            dispatch(setStaffDetails(updatedList));
          } else {
            const updatedRoles = user?.leadershipRole.filter((lr:any) => role !== lr );
            const updatedStaff = {...user, leadershipRole: updatedRoles};
            const updatedList = staffList?.map((item:any) => item?.id == updatedStaff?.id ? updatedStaff : item);
            dispatch(setStaffDetails(updatedList));
          }
        }
      });
      const boolean:any = true;
      dispatch(setIsUpdatedStaff(boolean));
  };

    return (
        <>
          <AutoComplete 
          options={options}
          selectedValues={selectedOption}
          handleMenuClick={handleChange} 
          label={t('')}
          clickReset={() => {}}
          isMultiple={true}
          variant={'standard'}
          isError={isEmpty(selectedOption) && !isReadOnly}
          errorMessage={t('REQUIRED')}
          isReadOnly={isReadOnly}
          />
        </>
    );
}

export default StaffMemberRolesAutocomplete;